import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import AuthNavigation from './Navigations/Auth/AuthNavigation';
import PagesNavigation from './Navigations/Pages/PagesNavigation';

function App() {
  const isLoggedIn = useSelector(({ auth: { isLoggedIn } }) => isLoggedIn);
  return isLoggedIn ? <PagesNavigation /> : <AuthNavigation />;
}

export default App;
